export default "__VITE_ASSET__BKtImKvY__ 300w";